// UNUSED WARNING
// const isPrimitiveArray = (obj: any) => {
//     return obj != null
//         && obj.getClass().isArray()
//         && obj.getClass().getComponentType() != null
//         && obj.getClass().getComponentType().isPrimitive();
// }

import { StringUtility } from '@common/utils/stringUtility';

const generateSearchQuery = (params: any) => {
  if (params === null || params === undefined) return undefined;

  const queryParams = Object.keys(params)
    .filter((key) => params[key] != null)
    .filter(
      (key) =>
        params[key] !== Object(params[key]) ||
        (Array.isArray(params[key]) &&
          (typeof params[key][0] === 'string' ||
            typeof params[key][0] === 'number')),
    )
    .filter((key) => params[key].toString().trim() !== '')
    .map((key) => {
      const rawValue = params[key].toString().trim();
      const escapedValue = StringUtility.escapeParenthesis(rawValue);
      return `(${key}: ${escapedValue})`;
    })
    .join(' AND ');

  return queryParams === '' ? undefined : queryParams;
};

export { generateSearchQuery };
